export class CtaRandom {
  constructor() {
    document.addEventListener('DOMContentLoaded', function () {
      const robotList = ['robot_t8', 'robot_t5', 'robot_t5pro', 'robot_w3', 'robot_lanky-porter', 'robot_kettybot', 'robot_holabot', 'robot_swiftbot', 'robot_pudubot2', 'robot_bellabot']
      let num = Math.floor(Math.random() * robotList.length)
      document.getElementById('js-cta_robot').src = '/img/common/robot/' + robotList[num] + '.png'
      document.getElementById('js-cta_robot').srcset = '/img/common/robot/' + robotList[num] + '.png 1x, /img/common/robot/' + robotList[num] + '@2x.png'
    })
  }
}
